import React from "react";
import { X, Phone, Mail } from "lucide-react";
import useStore from "../../store/useStore";

const MobileMenu = ({ currentPage, onNavigate }) => {
  const isOpen = useStore((state) => state.mobileMenuOpen);
  const setMobileMenuOpen = useStore((state) => state.setMobileMenuOpen);

  const handleNavigate = (page) => {
    onNavigate(page);
    setMobileMenuOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={() => setMobileMenuOpen(false)}
      />
      <div className="absolute top-0 left-0 h-full bg-white shadow-2xl w-80">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-2xl font-serif text-transparent bg-clip-text bg-gradient-to-r from-[#1a1a3e] to-[#d4af37]">
            MAISON DE BIJOUX
          </h3>
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="p-2 rounded-full hover:bg-gray-100"
          >
            <X className="w-6 h-6" />
          </button>
        </div>
        <nav className="p-6">
          <div className="space-y-2">
            {["home", "shop", "wishlist", "about", "contact"].map((page) => (
              <button
                key={page}
                onClick={() => handleNavigate(page)}
                className={`w-full text-left px-4 py-3 rounded-lg transition capitalize ${
                  currentPage === page
                    ? "bg-[#e8e4f3] text-[#1a1a3e] font-semibold"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                {{
                  home: "Maison",
                  shop: "Collections",
                  wishlist: "Your Favorites",
                  about: "Our Story",
                  contact: "Get in touch",
                }[page]}
              </button>
            ))}
          </div>
          <div className="pt-8 mt-8 border-t border-gray-200">
            <p className="mb-2 text-sm text-gray-600">Customer Service</p>
            <div className="space-y-3">
              <button
                onClick={() => window.open("tel:+15551234567")}
                className="flex items-center text-gray-700 hover:text-[#d4af37] transition w-full"
              >
                <Phone className="w-4 h-4 mr-2" />
                <span className="text-sm">+961 79 498 090</span>
              </button>
              <button
                onClick={() => window.open("mailto:info@maisonbijoux.com")}
                className="flex items-center text-gray-700 hover:text-[#d4af37] transition w-full"
              >
                <Mail className="w-4 h-4 mr-2" />
                <span className="text-sm">maisondebijoux.lb@gmail.com</span>
              </button>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
